import type { Block, Deck, Slide } from "./index.js";

/** The headline for a block: its title, or the question for polls and quizzes. */
export function blockTitle(block: Block): string {
  return block.type === "poll" || block.type === "quiz" ? block.question : block.title;
}

export function findBlock(deck: Deck, blockId: string): Block | undefined {
  for (const s of deck.sections) for (const b of s.blocks) if (b.id === blockId) return b;
  return undefined;
}

export function slideTitle(deck: Deck, slide: Slide): string {
  if (slide.kind === "title") return deck.title;
  if (slide.kind === "section") return deck.sections.find((s) => s.id === slide.sectionId)?.title ?? "";
  const block = findBlock(deck, slide.blockId);
  return block ? blockTitle(block) : "";
}

/** "The agent loop › Act" when zoomed into a node, "… › Question 2" on a pin; the slide title otherwise. */
export function nowTitle(deck: Deck, slides: Slide[], slideIndex: number, stop: number): string {
  const slide = slides[slideIndex];
  if (!slide) return "";
  const title = slideTitle(deck, slide);
  if (slide.kind !== "block" || stop === 0) return title;
  const block = findBlock(deck, slide.blockId);
  if (block?.type === "flow") {
    const node = block.nodes.filter((n) => n.detail)[stop - 1];
    return node ? `${title} › ${node.label}` : title;
  }
  if (block?.type === "screenshot") return `${title} › Question ${stop}`;
  if (block?.type === "timeline") {
    const item = block.items[stop];
    return item ? `${title} › ${item.label}` : title;
  }
  return title;
}
